import { render, staticRenderFns } from "./upComingLeave.vue?vue&type=template&id=c90cfd26&"
import script from "./upComingLeave.vue?vue&type=script&lang=js&"
export * from "./upComingLeave.vue?vue&type=script&lang=js&"
import style0 from "./upComingLeave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports